import {ROUTER_NAMES} from "@/constants/router.constants";
import FooterLayout from "@/layouts/FooterLayout.vue";

const CoachingLanding = () =>
  import(/* webpackChunkName: "onboarding" */ "@/pages/coaching-landing")

export default [
  {
    path: "/coaching",
    name: ROUTER_NAMES.COACHING_LANDING,
    component: CoachingLanding,
    meta: {
      layout: {
        component: FooterLayout,
      },
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/landing.routes.js